import React, { useEffect } from "react";

import "./loader.css";

import Video from "../../assets/loader.mp4";

function Preloader() {
	useEffect(() => {
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = "auto";
		};
	}, []);
	return (
		<div>
			<div className="Wrapper">
				<video loop autostart="true" autoPlay muted src={Video} type="video/mp4" className="Loader" />
			</div>
			<p>Hello</p>
		</div>
	);
}

export default Preloader;
